/* eslint-disable react/jsx-no-comment-textnodes */
import { useState, useEffect } from "react";
import styled from "styled-components";
import { useApp } from "../../contexts";
import { HeaderLanguage } from "./header.auth";
import Sidebar from "./sidebar";
import SidebarUserMobile  from "./sidebar.user";
import { ArrowDownIcon } from "../Icons/ArrowDownIcon";
import { DesktopContainer, MobileContainer } from "../Container";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LINKTR_URLS,
  LIST_MENU_BAR,
  PageIgnoreHeaderMobile,
  ZENDESK_URLS,
} from "../../constants";
import FormButton from "../FormCustom2/Button";
import { Dropdown, Menu, Space } from "antd";
import { SettingIcon } from "../Icons/SettingIcon";
import { ProfileIcon } from "../Icons/ProfileIcon";
import { MyPuchaseIcon } from "../Icons/MyPuchaseIcon";
import { SignoutIcon } from "../Icons/SignoutIcon";
import { HeaderLogo } from "../Icons/HeaderLogo";
import environment from "../../environment";
import useScrollDirection from "../../hook/useScrollDirection";
import { ModalPolicy } from "../AffiliateComponent/ModalPolicy";
import useAffiliate from "../../hook/useAffiliate";
import { MyAffiliateIcon } from "../Icons/MyAffiliateIcon";

const HeaderBlock = styled.div`
  padding-left: 0;
  padding-right: 0;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.03);
  backdrop-filter: blur(20px);
  height: 80px;
`;
const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  z-index: 10;
  padding: 0 15px;
  max-width: 100%;
  @media screen and (min-width: 768px) {
    padding-left: 30px;
    padding-right: 30px;
  }
  @media screen and (min-width: 1280px) {
    padding-left: 40px;
    padding-right: 40px;
  }
  @media screen and (min-width: 1440px) {
    padding-left: 60px;
    padding-right: 60px;
  }
  @media screen and (min-width: 1536px) {
    padding-left: 80px;
    padding-right: 80px;
  }
  @media screen and (min-width: 1920px) {
    padding-left: 105px;
    padding-right: 105px;
    max-width: 1920px;
  }
`;
const HeaderLeft = styled.div`
  cursor: pointer;
  align-items: center;
  display: flex;
`;
const HeaderCenter = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
`;
const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const HeaderMenu = styled.div`
  display: flex;
  align-items: center;
`;

const HeaderMenuItem = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin: 0 25px;
  padding: 0 5px;
  cursor: pointer;
  color: #000000;
  white-space: nowrap;
  &.active {
    position: relative;
    background: #F12E11;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
  @media screen and (max-width: 1320px) {
    & {
      margin: 0 14px;
      font-size: 16px;
    }
  }
  @media screen and (max-width: 1150px) {
    & {
      margin: 0 14px;
      font-size: 14px;
    }
  }
  @media screen and (max-width: 1120px) {
    & {
      margin: 0 7px;
      font-size: 14px;
    }
  }
`;
const HeaderUser = styled.div`
  display: flex;
  //margin-right: 32px;
  cursor: pointer;

  & span {
    margin-right: 12px;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    text-align: right;
    background: #F12E11;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }

  & img {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    object-fit: cover;
    @media screen and (max-width: 1280px) {
      width: 24px;
      height: 24px;
    }
  }
`;


const MContainer = styled.div`
  padding-left: 0;
  padding-right: 0;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.03);
  backdrop-filter: blur(20px);
  height: 72px;

`;
const MContainerTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 0;
  padding: 0 15px;
  @media screen and (min-width: 768px) {
    padding-left: 30px;
    padding-right: 30px;
  }
`;

const MLogo = styled.div`
  & svg {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: auto;
    @media screen and (max-width: 360px) {
      height: 32px;
    }
  }
`;

const MUser = styled.div`
  margin-right: 12px;
  width: 24px;
  height: 24px;
  border-radius: 24px;
  overflow: hidden;

  & img {
    width: 100%;
    height: 100%;
  }
`;
const MSidebar = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 24px;

  & svg {
    height: 24px;
  }
`;

export const MUserAvt = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50px;
  overflow: hidden;
  margin-right: 12px;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const MUserInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  & h1 {
    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
    color: #000;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & p {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    display: inline-block;
    max-width: 205px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #000;
  }

  &.minimized {
    & h1 {
      max-width: 140px;
    }

    & p {
      max-width: 140px;
    }
  }
`;

const EyeMemberBadge = styled.div`
  background: url("/assets/images/eye-member-badge.svg");
  height: 78px;
  width: 71.1px;
`;

const MMenuIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 12H21M3 6H21M3 18H21" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

const MenuInfoUserWraper = styled(Menu)`
  background: #ffffff;
  border-radius: 24px;
  overflow: hidden;
  padding: 0 0 10px 0;
  width: 320px;
  box-shadow: 0px 4px 40px #00000070;

  & li {
    &.ant-dropdown-menu-submenu {
      padding: 0;
      .ant-dropdown-menu-submenu-title{
        width: 100%;
        display: flex;
        height: 100%;
        align-items: center;
        gap: 14px;
        padding-left: 30px;
        padding-right: 16px;
      }
    }
    padding: 15px 16px 15px 30px;
    border-bottom: 1px solid #f5f5f5;
    height: 55px;
    &:last-child {
      border-bottom: none;
    }
    & span {
      display: flex;
      align-items: center;
      gap: 16px;
      font-weight: 500;
      font-size: 16px;
      line-height: 25px;
      color: #000000;
    }
  }
`;

const HeaderProfileWrapper = styled.div`
  background: url("/assets/images/header-profile-bg.svg");
  background-repeat: no-repeat;
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 22px;
  padding-right: 20px;
`;

const HeaderSubMenuView = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin: 0 25px;
  padding: 0 5px;
  cursor: pointer;
  color: #000000;
  gap: 6px;
  white-space: nowrap;
  svg {
    width: 12px;
    height: 12px;
  }
  @media screen and (max-width: 1320px) {
    & {
      margin: 0 16px;
      font-size: 14px;
    }
  }
  @media screen and (max-width: 1150px) {
    & {
      margin: 0 14px;
      font-size: 14px;
    }
  }
  @media screen and (max-width: 1120px) {
    & {
      margin: 0 7px;
      font-size: 14px;
    }
  }
`;
const MenuSubsWraper = styled(Menu)`
  background: #ffffff;
  border-radius: 24px;
  overflow: hidden;
  padding: 10px 0;
  min-width: 280px;
  & li {
    padding: 15px 16px 15px 16px;
    border-bottom: 1px solid #f5f5f5;
    height: 55px;
    &:last-child {
      border-bottom: none;
    }
    & span {
      display: flex;
      align-items: center;
      gap: 16px;
      font-weight: 500;
      font-size: 16px;
      line-height: 25px;
      color: #000000;
    }
  }
`;

const HeaderDesktop = ({ isAuth = true }) => {
  const { logout, T, user, isTabLogin, setPrePosition, language } = useApp();
  const location = useLocation();
  const navigate = useNavigate();
  const pathName = location.pathname;
  const scrollDirection = useScrollDirection();
  const handleRedirectAuth = (path) => {
    setPrePosition(null)
    navigate(path);
  };
  const [linkHelp, $linkHelp] = useState(ZENDESK_URLS.EN.HELP);
  const [socialLink, $socialLink] = useState(LINKTR_URLS.EN);
  const {
    onAffiliate,
    onConfirmPolicy,
    isOpenModalPolicy,
    setIsOpenModalPolicy,
  } = useAffiliate();

  useEffect(() => {
    const lan = language;
    if (lan === "ja") {
      $linkHelp(ZENDESK_URLS.JA.HELP);
      $socialLink(LINKTR_URLS.JA);
    } else if (lan === "ko") {
      $linkHelp(ZENDESK_URLS.KO.HELP);
      $socialLink(LINKTR_URLS.KO);
    } else if (lan === "cn") {
      $linkHelp(ZENDESK_URLS.CN.HELP);
      $socialLink(LINKTR_URLS.CN);
    } else if (lan === "tc") {
      $linkHelp(ZENDESK_URLS.TC.HELP);
      $socialLink(LINKTR_URLS.TC);
    } else if (lan === "vi") {
      $linkHelp(ZENDESK_URLS.VI.HELP);
      $socialLink(LINKTR_URLS.VI);
    } else if (lan === "id") {
      $linkHelp(ZENDESK_URLS.ID.HELP);
      $socialLink(LINKTR_URLS.ID);
    } else if (lan === "pt") {
      $linkHelp(ZENDESK_URLS.PT.HELP);
      $socialLink(LINKTR_URLS.PT);
    } else if (lan === "es") {
      $linkHelp(ZENDESK_URLS.ES.HELP);
      $socialLink(LINKTR_URLS.ES);
    } else {
      $linkHelp(ZENDESK_URLS.EN.HELP);
      $socialLink(LINKTR_URLS.EN);
    }
  }, [language]);

  const onMenuClick = ({ key }) => {
    switch (key) {
      case "my-profile":
        handleRedirectAuth("/profile");
        break;
      case "user-signout":
        logout();
        break;
      case "my-purchase":
        handleRedirectAuth("/my-purchase");
        break;
      case "change-password":
        handleRedirectAuth("/change-password");
        break;
      case "two-factor":
        handleRedirectAuth("/two-factor");
        break;
      case "payment-method":
        handleRedirectAuth("/payment-method");
        break;      
      case "address-book":
        handleRedirectAuth("/address-book");
        break;
      case "my-affiliate":
        onAffiliate();
        break;
      default:
    }
  };
  const onMenuSubClick = ({key}) => {
    const userLanguage = user?.language;
    switch (key) {
      case "stake":
        handleRedirectAuth('/stake');
        break;
        case "stake-for-option":
          handleRedirectAuth('/stake-for-option');
          break;
      case "mall":
        const shopifyLink = user?.store_shopify;
        const shopifyUrl = `${shopifyLink}?lang=${userLanguage}`;
        window.open(shopifyUrl, "_blank");
        break;
      case "market":
        window.open(`${environment.MARKETPLACE_URL}/marketplace?lang=${language}`, '_blank');
        break;
      case "social":
        window.open(socialLink, '_blank');
        break;
      case "help":
        window.open(linkHelp, '_blank');
        break;
      default:
    }
  }
  const truncate = (str) => {
    if (!str) return '';
    if (str.length > 18) {
      return str.slice(0, 18) + '...';
    }
    return str;
  }

  const hasEyeMemberBadge = user?.eyeMemberLabel;

  const optionsHeaderUser = () => {
    const { SubMenu } = Menu;
    return (
      <MenuInfoUserWraper onClick={onMenuClick}>
        <HeaderProfileWrapper>
          <div className="flex items-center">
            <MUserAvt>
              <img
                alt="Avatar"
                onError={(event) => {
                  event.target.onerror = null;
                  event.target.setAttribute("data-image", event.target.src);
                  event.target.src =
                    "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";
                }}
                src={
                  user?.avatar?.trim() ||
                  "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"
                }
              />
            </MUserAvt>
            <MUserInfo className={`${hasEyeMemberBadge ? 'minimized' : ''}`}>
              <h1 className="truncate">{truncate(user?.name?.trim()) || ""}</h1>
              <p>{user?.email?.trim() || ""}</p>
            </MUserInfo>
          </div>
          {hasEyeMemberBadge && <EyeMemberBadge/>}
        </HeaderProfileWrapper>

        <Menu.Item key="my-profile">
          <span>
            <ProfileIcon /> {T("My Profile")}
          </span>
        </Menu.Item>
        <Menu.Item key="my-purchase">
          <span>
            <MyPuchaseIcon /> {T("My Purchase")}
          </span>
        </Menu.Item>
        <Menu.Item key="my-affiliate">
          <span>
            <MyAffiliateIcon /> {T("My Affiliate")}
          </span>
        </Menu.Item>
        <SubMenu title={T("Settings")} icon={<SettingIcon />}>
          <Menu.Item key="change-password">
            <span className="flex min-w-[200px] h-[40px] items-center gap-[15px]">
              <ChangePassIcon /> {T("Password")}
            </span>
          </Menu.Item>
          <Menu.Item key="two-factor">
            <span className="flex min-w-[200px] h-[40px] items-center gap-[15px]">
              <FAIcon /> {T("2FA Authentication")}
            </span>
          </Menu.Item>
          <Menu.Item key="payment-method">
            <span className="flex min-w-[200px] h-[40px] items-center gap-[6px]">
              <PaymentIcon /> {T("Payment method")}
            </span>
          </Menu.Item> 
          <Menu.Item key="address-book">
            <span className="flex min-w-[200px] h-[40px] items-center gap-[6px]">
              <AddressBookIcon /> {T("Address book")}
            </span>
          </Menu.Item>
        </SubMenu>
        <Menu.Item key="user-signout">
          <span>
            <SignoutIcon /> {T("Sign out")}
          </span>
        </Menu.Item>
      </MenuInfoUserWraper>
    );
  };
  const optionsHeaderMenuSub = (subMenu) => {
    return (
      <MenuSubsWraper onClick={onMenuSubClick}>
        {subMenu && subMenu.map((menu, index) => <Menu.Item key={menu.key}>
            <span>
              {menu.icon()} {T(menu.title)}
            </span>
          </Menu.Item>)}
      </MenuSubsWraper>
    );
  };
  return (
    <>
      <HeaderBlock
        className={`${
          scrollDirection !== "down"
            ? scrollDirection === "up"
              ? "opacity-100 z-10 fixed w-full !lg:pr-[50px] !xl:pr-[100px] top-0"
              : "opacity-100 z-10"
            : "opacity-0 z-[-1]"
        }`}
      >
        <HeaderContainer>
          <HeaderLeft onClick={() => (window.location.href = `/`)}>
            <HeaderLogo style={{ cursor: "pointer" }} />
          </HeaderLeft>
          {isAuth && (
            <HeaderCenter>
              <HeaderMenu>
                {LIST_MENU_BAR.map((nav, index) =>
                  nav.subMenu && nav.subMenu.length > 0 ? (
                    <Dropdown
                      key={index}
                      trigger={["hover"]}
                      placement="bottomRight"
                      overlay={optionsHeaderMenuSub(nav.subMenu)}
                    >
                      <HeaderSubMenuView
                        className={
                          (pathName === nav.link ||
                            nav?.pathRelation?.includes(pathName)) &&
                          "active"
                        }
                      >
                        {T(nav.title)} <ArrowDownIcon />
                      </HeaderSubMenuView>
                    </Dropdown>
                  ) : (
                    <span
                      onClick={() => handleRedirectAuth(nav.link)}
                      key={index}
                    >
                      <HeaderMenuItem
                        className={
                          (pathName === nav.link ||
                            nav?.pathRelation?.includes(pathName)) &&
                          "active"
                        }
                      >
                        {T(nav.title)}
                      </HeaderMenuItem>
                    </span>
                  )
                )}
              </HeaderMenu>
            </HeaderCenter>
          )}
          <HeaderRight>
            {isAuth ? (
              <>
                <span className="mr-[40px]">
                  <HeaderLanguage withCode />
                </span>
                <Dropdown
                  trigger={["hover"]}
                  placement="bottomRight"
                  overlay={optionsHeaderUser()}
                >
                  <HeaderUser tabIndex={0}>
                    <img
                      alt="Avatar"
                      onError={(event) => {
                        event.target.onerror = null;
                        event.target.setAttribute(
                          "data-image",
                          event.target.src
                        );
                        event.target.src =
                          "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";
                      }}
                      src={
                        user?.avatar?.trim() ||
                        "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"
                      }
                    />
                  </HeaderUser>
                </Dropdown>
              </>
            ) : (
              <Space size={6}>
                <FormButton
                  className={isTabLogin ? "black" : "white"}
                  onClick={() => handleRedirectAuth("?tab=login")}
                >
                  {T("Login")}
                </FormButton>
                <FormButton
                  className={!isTabLogin ? "black" : "white"}
                  onClick={() => handleRedirectAuth("?tab=register")}
                >
                  {T("Sign up")}
                </FormButton>
              </Space>
            )}
          </HeaderRight>
        </HeaderContainer>
      </HeaderBlock>
      {isOpenModalPolicy && (
        <ModalPolicy
          onClose={() => setIsOpenModalPolicy(false)}
          handleSubmit={() => onConfirmPolicy()}
        ></ModalPolicy>
      )}
    </>
  );
};

const HeaderMobile = ({ isAuth }) => {
  const { user } = useApp();
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuUserVisible, setMenuUserVisible] = useState(false);
  const scrollDirection = useScrollDirection();
  const location = useLocation();
  const pathName = location.pathname;
  const navigate = useNavigate();
  
  let isHeader = true;
  for (let i = 0; i < PageIgnoreHeaderMobile.length; i++) {
    if (pathName.includes(PageIgnoreHeaderMobile[i])) {
      isHeader = false;
    }
  }
  if (!isHeader) return null;
  return (
    <>
      <MContainer
        className={`${
          scrollDirection !== "down"
            ? scrollDirection === "up"
              ? "opacity-100 z-10 fixed w-full"
              : "opacity-100 z-10"
            : "opacity-0 z-[-1]"
        }`}
      >
        <MContainerTop>
          <MLogo>
            <HeaderLogo onClick={() => navigate("/")} />
          </MLogo>
          {isAuth && (
            <>
              <div className="flex items-center">
                <MUser onClick={() => setMenuUserVisible(true)}>
                  <img
                    alt="Avatar"
                    onError={(event) => {
                      event.target.onerror = null;
                      event.target.setAttribute("data-image", event.target.src);
                      event.target.src =
                        "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";
                    }}
                    src={
                      user?.avatar?.trim() ||
                      "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"
                    }
                  />
                </MUser>
                <MSidebar onClick={() => setMenuVisible(true)}>
                  <MMenuIcon />
                </MSidebar>
              </div>
            </>
          )}
        </MContainerTop>
      </MContainer>
      {menuVisible ? <Sidebar onClose={() => setMenuVisible(false)} /> : null}
      {menuUserVisible ? (
        <SidebarUserMobile onClose={() => setMenuUserVisible(false)} />
      ) : null}
    </>
  );
};

export default function Header(props) {
  return (
    <>
      <MobileContainer>
        <HeaderMobile {...props} />
      </MobileContainer>
      <DesktopContainer>
        <HeaderDesktop {...props} />
      </DesktopContainer>
    </>
  );
};
const FAIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
  >
    <path
      d="M12.8994 3.87753C12.8904 3.47637 12.8814 3.09265 12.8814 2.72637C12.8814 2.43858 12.6394 2.20311 12.3435 2.20311C10.0394 2.20311 8.29109 1.55776 6.82971 0.179855C6.6235 -0.0207264 6.29178 -0.0207264 6.0766 0.179855C4.62419 1.55776 2.86695 2.20311 0.571776 2.20311C0.275914 2.20311 0.0338447 2.43858 0.0338447 2.72637C0.0338447 3.09265 0.0248792 3.47637 0.0159137 3.87753C-0.0558105 7.63625 -0.154431 12.7816 6.28281 14.9444C6.3366 14.9618 6.39936 14.9706 6.46212 14.9706C6.52488 14.9706 6.57867 14.9618 6.64143 14.9444C13.0697 12.7816 12.9711 7.63625 12.8994 3.87753ZM6.45316 13.9066C0.930397 11.9531 1.02005 7.67986 1.09178 3.90369C1.09178 3.67695 1.10074 3.45893 1.10074 3.2409C3.25247 3.15369 4.97384 2.51706 6.45316 1.26997C7.93247 2.51706 9.65384 3.15369 11.8056 3.2409C11.8056 3.45893 11.8145 3.67695 11.8145 3.90369C11.8952 7.67986 11.9759 11.9531 6.45316 13.9066Z"
      fill="#818181"
    />
  </svg>
);
const PaymentIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3.20837 8.85637C3.20837 7.83129 3.20837 7.31875 3.41103 6.92862C3.58181 6.59986 3.84986 6.33181 4.17862 6.16103C4.56875 5.95837 5.08129 5.95837 6.10637 5.95837H15.8937C16.9188 5.95837 17.4313 5.95837 17.8215 6.16103C18.1502 6.33181 18.4183 6.59986 18.5891 6.92862C18.7917 7.31875 18.7917 7.83129 18.7917 8.85637V14.0604C18.7917 15.0855 18.7917 15.598 18.5891 15.9881C18.4183 16.3169 18.1502 16.5849 17.8215 16.7557C17.4313 16.9584 16.9188 16.9584 15.8937 16.9584H6.10637C5.08129 16.9584 4.56875 16.9584 4.17862 16.7557C3.84986 16.5849 3.58181 16.3169 3.41103 15.9881C3.20837 15.598 3.20837 15.0855 3.20837 14.0604V8.85637Z" stroke="#666666"/>
  <path d="M3.20837 9.625L18.7917 9.625" stroke="#666666" stroke-linecap="round"/>
  <ellipse cx="5.95833" cy="14.2083" rx="0.458333" ry="0.458333" fill="#666666"/>
  </svg>

);
const AddressBookIcon = (props) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M17.5 6.125L3.5 6.125" stroke="black" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M13.125 10.5L3.5 10.5" stroke="black" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M7.875 14.875H3.5" stroke="black" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round"/>
  </svg>


);
const ChangePassIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
  >
    <path
      d="M10.5 15H1.5C0.675 15 0 14.3711 0 13.5937V7.03125C0 6.25391 0.675 5.625 1.5 5.625H10.5C11.325 5.625 12 6.25391 12 7.03125V13.5937C12 14.3711 11.325 15 10.5 15ZM1.5 6.5625C1.225 6.5625 1 6.77344 1 7.03125V13.5937C1 13.8516 1.225 14.0625 1.5 14.0625H10.5C10.775 14.0625 11 13.8516 11 13.5937V7.03125C11 6.77344 10.775 6.5625 10.5 6.5625H1.5Z"
      fill="#818181"
    />
    <path
      d="M9.5 6.5625C9.225 6.5625 9 6.35156 9 6.09375V3.75C9 2.19922 7.65417 0.9375 6 0.9375C4.34583 0.9375 3 2.19922 3 3.75V6.09375C3 6.35156 2.775 6.5625 2.5 6.5625C2.225 6.5625 2 6.35156 2 6.09375V3.75C2 1.68359 3.79583 0 6 0C8.20417 0 10 1.68359 10 3.75V6.09375C10 6.35156 9.775 6.5625 9.5 6.5625Z"
      fill="#818181"
    />
    <path
      d="M5.99984 10.625C5.2665 10.625 4.6665 10.0625 4.6665 9.375C4.6665 8.6875 5.2665 8.125 5.99984 8.125C6.73317 8.125 7.33317 8.6875 7.33317 9.375C7.33317 10.0625 6.73317 10.625 5.99984 10.625ZM5.99984 9.0625C5.8165 9.0625 5.6665 9.20313 5.6665 9.375C5.6665 9.54688 5.8165 9.6875 5.99984 9.6875C6.18317 9.6875 6.33317 9.54688 6.33317 9.375C6.33317 9.20313 6.18317 9.0625 5.99984 9.0625Z"
      fill="#818181"
    />
    <path
      d="M6 12.5C5.725 12.5 5.5 12.2891 5.5 12.0312V10.3125C5.5 10.0547 5.725 9.84375 6 9.84375C6.275 9.84375 6.5 10.0547 6.5 10.3125V12.0312C6.5 12.2891 6.275 12.5 6 12.5Z"
      fill="#818181"
    />
  </svg>
);